module.exports = __webpack_public_path__ + "static/media/logo-proceda.1494deed.svg";